const SERVER_API = 'http://es-sand.shreegrgoilmill.com/backend/public/api';
export{SERVER_API}; 
//esource